import { Typography } from '@mui/material';
import { colors } from '@/theme';

// Helper to format time remaining for compact display
const formatCompactTime = (seconds) => {
  // -1 means expiration hasn't started yet (e.g., token not activated)
  if (seconds < 0) return 'Pending';
  if (seconds === 0) return 'Expired';

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (days > 0) {
    return `${days}d ${hours}h`;
  }
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
};

const ExpirationBadge = ({ timeRemaining, urgent = false }) => {
  const displayText = formatCompactTime(timeRemaining);
  const isExpired = timeRemaining === 0;
  const isPending = timeRemaining < 0;

  const textColor = isExpired
    ? colors.error.main
    : isPending
      ? colors.grey[500]
      : urgent
        ? colors.warning.main
        : colors.grey[700];

  return (
    <Typography
      variant="body2"
      sx={{
        color: textColor,
        fontWeight: urgent || isExpired ? 600 : 400,
        fontStyle: isPending ? 'italic' : 'normal',
        fontSize: '0.875rem',
      }}
    >
      {displayText}
    </Typography>
  );
};

export default ExpirationBadge;
